import React from 'react';
import { ITournamentBannerContextData } from '../../../../marketing-ui/src/pages/dashboard/lobbyBanner/utils/constants'

export interface IlobbyBannerContext {
    lobbyBannerData: ITournamentBannerContextData
    setLobbyBannerData: Function
}

const lobbyBannerContext = React.createContext<IlobbyBannerContext>({} as IlobbyBannerContext);

export default lobbyBannerContext;
